import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { CoreValues } from './components/CoreValues';
import { Categories } from './components/Categories';
import { HowItWorks } from './components/HowItWorks';
import { TrustSection } from './components/TrustSection';
import { CTASection } from './components/CTASection';
import { Footer } from './components/Footer';

export default function PlatformPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <CoreValues />
      <Categories />
      <HowItWorks />
      <TrustSection />
      <CTASection />
      <Footer />
    </div>
  );
}
